export default __webpack_public_path__ + "static/media/IMAGE_7.45a10772.png";